import React from 'react'
import View from './View'
import StepProvider from '@/Components/formik-steps/StepProvider'
import FormProvider from '@/Components/formik-steps/FormProvider'
import TextInput from '@/Components/formik-steps/TextInput'
import Dropdown from '@/Components/formik-steps/Dropdown'
import TextArea from '@/Components/formik-steps/TextArea'
import * as yup from 'yup'

/**
 *
 * @returns {React.Element}
 * @constructor
 */
const FormikSteps = ({
    initialValues = {},
    beforeSubmitting,
    useCachedValuesCallback = async function (values) { return values },
    beforeCaching = function (values) { return values },
    initialValidationSchema = yup.object(),
    initialSteps = [],
    onSuccess = function () { },
    env = {},
    onError = function () { }
}) => {
    return (
        <FormProvider useCachedValuesCallback={useCachedValuesCallback} beforeCaching={beforeCaching} intitialValidationSchema={initialValidationSchema} env={env} beforeSubmitting={beforeSubmitting} initialValues={initialValues} onSuccess={onSuccess} onError={onError}>
            <StepProvider
                env={env}
                initialSteps={initialSteps}>
                <View />
            </StepProvider>
        </FormProvider>
    )
}

export default FormikSteps
export { createStep } from './Step'
export { useForm, useSteps } from './consumers'
export { TextInput, Dropdown, TextArea }
export { FormProvider }